<template>
    <div>
        <PrintersDialog
            :is-open="printersDialog"
            :printers="printers"
            :delivery-data="delivery"
            @on-save="printZPL"
            @on-close="closePrintersDialog"
        />
        <v-dialog
            :value="isOpen"
            scrollable
            max-width="600px"
            transition="slide-y-transition"
            origin="top center"
            eager
            @keydown.esc="onClose"
            @click:outside="onClose"
        >
            <v-card>
                <v-card-title>
                    <h1 class="text-subtitle-1">
                        Listy przewozowe
                    </h1>
                </v-card-title>

                <v-card-text>
                    <v-container class="pa-0">
                        <v-row>
                            <v-col cols="12">
                                <v-data-table
                                    :headers="headers"
                                    :items="delivery.sendingLabels"
                                    :mobile-breakpoint="0"
                                    hide-default-footer
                                    disable-pagination
                                    name="sendingsData"
                                >
                                    <template #item.labelNumber="{item}">
                                        {{ parseEmptyValue(item.labelNumber) }}
                                    </template>
                                    <template #item.carrier="{item}">
                                        {{ parseEmptyValue(item.carrier) }}
                                    </template>
                                    <template #item.actions="{item}">
                                        <div class="d-inline-flex">
                                            <v-tooltip :open-delay="tooltipDelay" top>
                                                <template #activator="{on}">
                                                    <v-btn
                                                        icon
                                                        data-sentry-label="Generuj pdf"
                                                        :disabled="!item.file"
                                                        v-on="on"
                                                        @click="openInNewTab(item.file)"
                                                    >
                                                        <v-icon color="secondary">
                                                            mdi-file-pdf-box
                                                        </v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Generuj pdf</span>
                                            </v-tooltip>
                                            <v-tooltip :open-delay="tooltipDelay" top>
                                                <template #activator="{on}">
                                                    <v-btn
                                                        icon
                                                        data-sentry-label="Drukuj zpl"
                                                        :disabled="actionLoading || !item.file"
                                                        v-on="on"
                                                        @click="showPrintersDialog()"
                                                    >
                                                        <v-icon color="blue">
                                                            mdi-printer-pos
                                                        </v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Drukuj zpl</span>
                                            </v-tooltip>
                                        </div>
                                    </template>
                                </v-data-table>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-divider />
                <v-card-actions>
                    <v-btn
                        color="error"
                        text
                        data-sentry-label="Anuluj"
                        @click="onClose"
                    >
                        Anuluj
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import PrintersDialog from './PrintersDialog'
import { errorHandler } from '@/utils/errorHandler'
import { apiConfig } from '@/config'
import tooltipDelay from '@/mixins/tooltip'
import parse from '@/mixins/parse'


export default {
    name: 'SendingsDialog',
    components: { PrintersDialog },
    mixins: [ tooltipDelay, parse ],
    props: {
        isOpen: {
            type: Boolean
        },
        deliveryData: {
            type: Object,
            default: () => {}
        },
        printers: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            zpl: {
                printer: null,
                delivery: null
            },
            delivery: {
                sendingLabels: []
            },
            actionLoading: false,
            printersDialog: false,
            headers: [
                {
                    text: 'Numer listu przewozowego',
                    value: 'labelNumber',
                    sortable: false
                },
                {
                    text: 'Metoda wysyłki',
                    value: 'carrier',
                    sortable: false
                },
                {
                    text: 'Akcje',
                    value: 'actions',
                    sortable: false,
                    align: 'center'
                },
            ]
        }
    },
    watch: {
        isOpen(boolean) {
            if (boolean) {
                this.delivery = JSON.parse(JSON.stringify(this.deliveryData))
            }
        }
    },
    methods: {
        showPrintersDialog() {
            this.printersDialog = true
            this.$emit('on-close')
        },
        closePrintersDialog() {
            this.printersDialog = false
            this.$emit('show-sendings-dialog')
        },
        printZPL(payload) {
            this.zpl.printer = payload.printerId
            this.zpl.delivery = payload.delivery.id
            this.delivery = payload.delivery
            this.actionLoading = true
            this.$store.dispatch('orders/printZPL', this.zpl)
                .then(() => {
                    this.$store.dispatch('showNotification', {
                        type: 'success',
                        message: 'ZPL został wydrukowany.'
                    })
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.actionLoading = false
                })
        },
        openInNewTab(file) {
            const mediaRoot = apiConfig.FACTORYBASE_API_URI

            window.open(`${mediaRoot}${file}`, '_blank').focus()
        },
        onClose() {
            this.$emit('on-close')
            setTimeout(() => {
                this.zpl = {
                    printer: null,
                    delivery: null
                }
                this.delivery = {
                    sendingLabels: []
                }
            }, 500)
        }
    }
}
</script>

